import { defineComponent as _defineComponent } from 'vue'
import MyProjectsSectionHeader from '@/views/my-projects/components/MyProjectsSectionHeader.vue';
import { useMyProjects } from '@/views/my-projects/composables/useMyProjects';
import MyProjectsOfferDetail from '@/views/my-projects/components/offer-details/MyProjectsOfferDetail.vue';
import { computed } from 'vue';
import { ProjectOfferWithProjectReference } from '@/models/MyProjects';
import MyProjectsOffersTable from '@/views/my-projects/components/offers/MyProjectsOffersTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsMadeOffers',
  setup(__props) {

const {
  madeProjectsWithOffers,
} = useMyProjects();

// unfold offers
const madeProjectOffers = computed(() => {
  let offers: ProjectOfferWithProjectReference[] = [];
  madeProjectsWithOffers.value.forEach((projectWithOffers) => {
    const projectOffers = projectWithOffers.offers.map((offer) => ({ ...offer, project: projectWithOffers.project }));
    offers = [...offers, ...projectOffers];
  });
  return offers;
});


return { __sfc: true,madeProjectsWithOffers, madeProjectOffers, MyProjectsSectionHeader, MyProjectsOfferDetail, MyProjectsOffersTable }
}

})